// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"89b10d3f","69":"c2afe27c","82":"5f9d2c97","603":"129ffd22","687":"e80c36c4","786":"c7eae7dd"}[chunkId] + ".chunk.js";
};